import type { FC } from 'react';
import cx from 'classnames';

import type { VehicleListQuery } from 'Components/Account/AccountPage.types';
import { PromotionsBanner } from 'Components/PromotionsBanner/PromotionsBanner';
import { useSellerCommunicationsStatus } from 'Features/SellerCommunications';
import { triggerBulkBuyingPromotionModalOpened } from 'Services/analytics/events/bulkBuyingPromotionEvents';
import type { AccountSlugs } from 'Types/account';

import { Filters } from '../Filters/Filters';

import { PurchasesVehicleList } from './PurchasesVehicleList/PurchasesVehicleList';
import { isCompletedPage } from './Purchases.helpers';

import styles from './Purchases.module.scss';

type PurchasesProps = VehicleListQuery & {
	slug: AccountSlugs;
};

const onPromotionsBannerExplanationClicked = () =>
	triggerBulkBuyingPromotionModalOpened('Bidding and purchase history');

const Purchases: FC<PurchasesProps> = ({ data, isPreviousData, queryStatus, slug }) => {
	const isCompleteSlug = isCompletedPage(slug);
	const statuses = useSellerCommunicationsStatus();

	return (
		<>
			<Filters
				data={data}
				gridClass={cx({
					[styles.completeGrid]: isCompleteSlug,
					[styles.cancelledGrid]: !isCompleteSlug,
				})}
				queryStatus={queryStatus}
			/>
			<div data-has-promotions className={styles.promotionsBannerContainer}>
				<PromotionsBanner
					containerClassName={styles.promotionsBanner}
					onExplanationClick={onPromotionsBannerExplanationClicked}
				/>
			</div>
			<PurchasesVehicleList
				communicationStatus={statuses}
				data={data}
				isPreviousData={isPreviousData}
				queryStatus={queryStatus}
			/>
		</>
	);
};

export { Purchases };
